import { z } from 'zod';

export enum CheckWritingGraderType {
  LETTER = 'LETTER',
}

export enum CheckWritingEvaluation {
  CORRECT = 'CORRECT',
  INCORRECT = 'INCORRECT',
  REVERSE = 'REVERSE',
}

export const CheckWritingResultSchema = z.object({
  storageKey: z.string(),
  evaluation: z.nativeEnum(CheckWritingEvaluation),
});
export type CheckWritingResult = z.infer<typeof CheckWritingResultSchema>;

export const CheckWritingInputSchema = z.object({
  userPath: z.string(),
  referencePath: z.string(),
  reference: z.string(),
  type: z.nativeEnum(CheckWritingGraderType),
});
export type CheckWritingInput = z.infer<typeof CheckWritingInputSchema>;
